import { Box } from '@mui/material';
import React, { useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';
import dayjs from 'dayjs';
import { Swiper, SwiperSlide } from 'swiper/react';
import PinchZoom from '../../../Components/Ui/PinchZoom';
import Global from '../../../Services/Common/Global';
import { Pagination } from 'swiper/modules';
import { useSelector, useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { Button } from '../../../Components/MUIs';
import SignWorkEndBottomSheet from '../ui/SignWorkEndBottomSheet';

export default function M_WOE_BASIC_02(props) {
  const [beforeIndex, setBeforeIndex] = useState(0);
  const [afterIndex, setAfterIndex] = useState(0);
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box>
        <Box sx={{ fontSize: '16px', color: '#918A8A' }}>
          <span
            style={{ fontSize: '20px', fontWeight: 'bold', color: '#3A3A3A' }}
          >
            작업이 종료되었습니다.
          </span>
          <br />
          개선 내용이 있는지 확인해주세요.
        </Box>

        {props.beforeImageList && props.beforeImageList.length > 0 ? (
          <Box sx={{ position: 'relative', my: 1 }}>
            <Swiper
              modules={[Pagination]}
              slidesPerView={1}
              nested={true}
              style={{
                width: '100%',
                height: '300px',
                borderRadius: '8px',
                border: '1px solid #DFD9D9',
              }}
              onSlideChange={(swiper) => setBeforeIndex(swiper.realIndex)}
            >
              {props.beforeImageList.map((img, idx) => (
                <SwiperSlide key={idx}>
                  <PinchZoom
                    componentWrapperStyle={{ width: '100%', height: '100%' }}
                    componentContentStyle={{ width: '100%', height: '100%' }}
                    contents={
                      <Box
                        sx={{
                          width: '100%',
                          height: '300px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          src={`${Global.file.useUrl}files/${img}`}
                          alt={`stop-img-${idx}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                      </Box>
                    }
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* 하단 인덱스 표시 */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 8,
                right: 12,
                background: 'rgba(0,0,0,0.6)',
                color: '#fff',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                zIndex: 10,
              }}
            >
              {beforeIndex + 1} / {props.beforeImageList.length}
            </Box>
          </Box>
        ) : (
          <Box sx={{ px: 1, my: 1 }}>
            <Box
              sx={{
                width: '100%',
                height: '200px',
                backgroundColor: '#f3f1f1ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px',
                px: 1,
              }}
            >
              <Icon.WorkInfoBaseImg width={50} height={40} />
            </Box>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontWeight: 'bold',
            pl: '0.5px',
          }}
        >
          <Icon.User width={20} />{' '}
          <p style={{ color: '#DD8B44' }}>{props.rowData1?.name}</p>
          <p>{props.rowData1?.position}</p>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontWeight: 'bold',
          }}
        >
          <Icon.Date width={22} />
          <p>{dayjs(props.rowData1.createDate).format('YYYY-MM-DD HH:mm')}</p>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: '#fafafaff',
            p: 1,
            borderRadius: 1,
            my: 1,
          }}
        >
          {props.rowData1?.beforeComment}
        </Box>
        {props.rowData1?.afterComment && (
          <Box
            sx={{
              fontWeight: 'bold',
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <hr
              style={{
                border: 'none',
                borderTop: '2px solid #7c7777ff',
                margin: '4px 0',
              }}
            />
            <p
              style={{ fontSize: '20px', fontWeight: 'bold', color: '#3A3A3A' }}
            >
              조치사항{' '}
            </p>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <p>조치자 </p>
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <p style={{ color: '#DD8B44' }}>
                  {props.rowData1?.solverName}{' '}
                </p>
                <p>{props.rowData1?.solverPosition} </p>
                <p>{props.rowData1?.solverDepNmLast} </p>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <p>조치일시 </p>
              <p style={{ color: '#DD8B44' }}>
                {dayjs(props.rowData1?.updateDate).format('YYYY-MM-DD HH:mm')}
              </p>
            </Box>
            <Box>
              {props.afterImageList && props.afterImageList.length > 0 && (
                <Box sx={{ position: 'relative', my: 1 }}>
                  <Swiper
                    modules={[Pagination]}
                    slidesPerView={1}
                    nested={true}
                    style={{
                      width: '100%',
                      height: '300px',
                      borderRadius: '8px',
                      border: '1px solid #DFD9D9',
                    }}
                    onSlideChange={(swiper) => setAfterIndex(swiper.realIndex)}
                  >
                    {props.afterImageList.map((img, idx) => (
                      <SwiperSlide key={idx}>
                        <PinchZoom
                          componentWrapperStyle={{
                            width: '100%',
                            height: '100%',
                          }}
                          componentContentStyle={{
                            width: '100%',
                            height: '100%',
                          }}
                          contents={
                            <Box
                              sx={{
                                width: '100%',
                                height: '300px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                src={`${Global.file.useUrl}files/${img}`}
                                alt={`stop-img-${idx}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            </Box>
                          }
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* 하단 인덱스 표시 */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 8,
                      right: 12,
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fff',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      zIndex: 10,
                    }}
                  >
                    {afterIndex + 1} / {props.afterImageList.length}
                  </Box>
                </Box>
              )}
              <p
                style={{
                  color: '#DD8B44',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  backgroundColor: '#fafafaff',
                  p: 1,
                  borderRadius: 1,
                  marginBottom: '1rem ',
                }}
              >
                {props.rowData1?.afterComment}
              </p>
            </Box>
          </Box>
        )}
      </Box>

      {/* 하단 버튼 */}
      <Box
        sx={{
          pb: 2,
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Button
          name={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                width: '100%',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              개선 내용 작성
            </Box>
          }
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow:
              '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
          }}
          onClick={() => {
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'signWorkEnd',
              })
            );
          }}
        />
      </Box>

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'signWorkEnd' && (
        <SignWorkEndBottomSheet
          previewList={props.previewList}
          setPreviewList={props.clearFiles}
          DeletePreview={props.DeletePreview}
          FileChange={props.FileChange}
          setWorkEndInputs={props.setWorkEndInputs}
          workEndInputs={props.workEndInputs}
          SaveLogic1={props.SaveLogic1}
        />
      )}
    </Box>
  );
}
